/**
 * Created by Abner Sui on 01/22/2020
 * -------------------------------------
 */

export enum KanbanCardAction {
    ON_MEAT_BALL = 'ON_MEAT_BALL',
}
